<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
-->
<!-- IP-NOTICE: MIXED -->
<!--<h3>OTP</h3>-->

<form id="otpForm" [formGroup]="otpDataForm" (ngSubmit)="onSubmitOtp()" novalidate>
	<div class="flex-layout-row flex-layout-gap-30px">
		<mat-form-field>
			<input formControlName="otpDigit1" matInput maxlength="1" #otpDigit1Input (input)="onDigitChanged(1)" />
		</mat-form-field>
		<mat-form-field>
			<input formControlName="otpDigit2" matInput maxlength="1" #otpDigit2Input (input)="onDigitChanged(2)" />
		</mat-form-field>
		<mat-form-field>
			<input formControlName="otpDigit3" matInput maxlength="1" #otpDigit3Input (input)="onDigitChanged(3)" />
		</mat-form-field>
		<mat-form-field>
			<input formControlName="otpDigit4" matInput maxlength="1" #otpDigit4Input (input)="onDigitChanged(4)" />
		</mat-form-field>
		<mat-form-field>
			<input formControlName="otpDigit5" matInput maxlength="1" #otpDigit5Input (input)="onDigitChanged(5)" />
		</mat-form-field>
		<mat-form-field>
			<input formControlName="otpDigit6" matInput maxlength="1" #otpDigit6Input (input)="onDigitChanged(6)" />
		</mat-form-field>
	</div>
	
	<div>
		<mat-error *ngIf="otpDigit1.touched && otpDigit1.errors?.required">
			OTP Digit 01 is required.
		</mat-error>
		<mat-error *ngIf="otpDigit1.touched && otpDigit1.errors?.maxlength">
			OTP Digit 01 must be no more than 1 character
		</mat-error>
		<mat-error *ngIf="otpDigit2.touched && otpDigit2.errors?.required">
			OTP Digit 02 is required.
		</mat-error>
		<mat-error *ngIf="otpDigit2.touched && otpDigit2.errors?.maxlength">
			OTP Digit 02 must be no more than 1 character
		</mat-error>
		<mat-error *ngIf="otpDigit3.touched && otpDigit3.errors?.required">
			OTP Digit 03 is required.
		</mat-error>
		<mat-error *ngIf="otpDigit3.touched && otpDigit3.errors?.maxlength">
			OTP Digit 03 must be no more than 1 character
		</mat-error>
		<mat-error *ngIf="otpDigit4.touched && otpDigit4.errors?.required">
			OTP Digit 04 is required.
		</mat-error>
		<mat-error *ngIf="otpDigit4.touched && otpDigit4.errors?.maxlength">
			OTP Digit 04 must be no more than 1 character
		</mat-error>
		<mat-error *ngIf="otpDigit5.touched && otpDigit5.errors?.required">
			OTP Digit 05 is required.
		</mat-error>
		<mat-error *ngIf="otpDigit5.touched && otpDigit5.errors?.maxlength">
			OTP Digit 05 must be no more than 1 character
		</mat-error>
		<mat-error *ngIf="otpDigit6.touched && otpDigit6.errors?.required">
			OTP Digit 06 is required.
		</mat-error>
		<mat-error *ngIf="otpDigit6.touched && otpDigit6.errors?.maxlength">
			OTP Digit 06 must be no more than 1 character
		</mat-error>

	</div>

	<div class="flex-layout-row flex-layout-gap-10px">
		<button class="submitBtn" mat-raised-button type="submit" color="primary" #otpSubmitButton>Submit OTP</button>
		<button mat-raised-button (click)="onResendOtp($event)">Re-send OTP</button>
	</div>

</form>